import { Suspense, lazy, ElementType } from 'react';
// components
import LoadingScreen from '../xx_minimalUi_old/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import('../xx_minimalUi_old/minimalui/LoginPage')));

export const Main = Loadable(lazy(() => import('../pages/Main')));

export const Page404 = Loadable(lazy(() => import('../xx_minimalUi_old/minimalui/Page404')));
